export default class showcaseSlide {

    static init() {

        $('.showcase-slide').slick({
            dots: true,
            arrows: false,
            autoplay: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: true
        });

    }

}